

import * as actions from './Actiontypes';


export const reducer = (state, action) => {
    switch (action.type) {
        case actions.ADD_MOVIE_TO_Watchlist:
            return {
                ...state,
                watchlist: [action.payload, ...state.watchlist]
            };
        case actions.REMOVE_MOVIE_FROM_WATCHLIST:
            return {
                ...state,
                watchlist: state.watchlist.filter((movie) => movie.imdbID !== action.payload)
            };  
        case actions.MOVE_TO_WATCHLIST:
            return {
                ...state,
                watched: state.watched.filter
                    ((movie) => movie.imdbID !== action.payload.imdbID),
                    watchlist: [...state.watchlist, action.payload]

            };



            case actions.ADD_MOVIE_TO_WATHCED:
                return {
                    ...state,
                    watchlist: state.watched.filter((movie)=> movie.imdbID!==action.payload.imdbID),
                    watched:[action.payload, ...state.watched]
                };
            case actions.REMOVE_MOVIE_FROM_WATCHED:
                return {
                    ...state,
                    watched: state.watchlist.filter((movie) => movie.imdbID !== action.payload)
                };
                default:
                    return state;
                }
            }
  